/**
 * Tile que aparece en el origin picker cuando la feature `tables` está ON.
 * Renderiza el tile "Mesa" y, cuando está seleccionado, el input de número.
 *
 * Reside aquí (y no en `pages/`) para que en Fase 6 el move a
 * `packages/features/tables` sea un `git mv` limpio — el page que lo
 * consume ya vive detrás de un feature flag.
 */

import { ConciergeBell } from 'lucide-react';

import { OriginTile } from '../../components/OriginTile.js';

interface Props {
  selected: boolean;
  onClick: () => void;
}

export const TableOriginTile = ({ selected, onClick }: Props) => (
  <OriginTile
    icon={ConciergeBell}
    label="Mesa"
    description="Cliente sentado. Requiere número de mesa."
    selected={selected}
    onClick={onClick}
  />
);

interface FieldProps {
  id: string;
  value: string;
  onChange: (v: string) => void;
}

export const TableNumberField = ({ id, value, onChange }: FieldProps) => (
  <div className="mt-6 rounded-md border border-border bg-surface p-6">
    <label htmlFor={id} className="block text-sm font-semibold tracking-tight">
      Número de mesa
    </label>
    <input
      id={id}
      inputMode="numeric"
      autoFocus
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="5"
      className="mt-2 w-32 rounded-md border border-border bg-surface px-3 py-2 text-2xl font-bold outline-none focus:border-fg"
    />
  </div>
);
